module.exports = __webpack_public_path__ + "static/media/dress-code4.e07bfd8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dressCode/dress-code4.jpg
// module id = 705
// module chunks = 0